var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHasVideo2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66602 6.51742C1.66602 5.21931 2.71834 4.16699 4.01644 4.16699H10.854C12.1522 4.16699 13.2045 5.21931 13.2045 6.51742V7.18962L16.168 5.70783C17.1626 5.21058 18.3327 5.93376 18.3327 7.04565V12.8268C18.3327 13.9387 17.1626 14.6619 16.168 14.1646L13.2045 12.6828V13.355C13.2045 14.6531 12.1522 15.7055 10.854 15.7055H4.01644C2.71834 15.7055 1.66602 14.6531 1.66602 13.355V6.51742ZM11.9224 11.6317C11.9222 11.6407 11.9222 11.6496 11.9224 11.6585V13.355C11.9224 13.9451 11.4441 14.4234 10.854 14.4234H4.01644C3.42639 14.4234 2.94807 13.9451 2.94807 13.355V6.51742C2.94807 5.92737 3.42639 5.44904 4.01644 5.44904H10.854C11.4441 5.44904 11.9224 5.92737 11.9224 6.51742V8.21394C11.9222 8.22284 11.9222 8.23176 11.9224 8.24069V11.6317ZM13.2045 11.2494L16.7414 13.0179C16.8835 13.0889 17.0506 12.9856 17.0506 12.8268V7.04565C17.0506 6.88681 16.8835 6.7835 16.7414 6.85454L13.2045 8.623V11.2494Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHasVideo2);
export default __webpack_public_path__ + "static/media/has-video-2.5cab9076bb7338988532c50a6609c9af.svg";
export { ForwardRef as ReactComponent };